import axios from 'axios';
import { useAdminStore } from '../store/adminStore';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const adminApi = axios.create({
  baseURL: `${API_URL}/api/admin-panel`,
  headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.request.use((config) => {
  const token = useAdminStore.getState().accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token bad/expired \u2192 boot back to the login screen.
      useAdminStore.getState().adminLogout();
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);
